import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CalculationResultCreateDto,
  CalculationResultUpdateDto,
} from '../proxy/inventory/dtos/calculation-result';
import { CALCULATIONRESULT_CONFIG, CALCULATIONRESULT_FIELDS } from './calculation-result.config';
import { BaseCrudComponent, CrudPage, GenericForm, ICrudService } from '@zendra/shared';
import { throwError } from 'rxjs';
import { CalculationResultPlanningOrchestratorService } from './calculation-result-orchestrator.service';
import {
  CalculationResultProjectionDto,
  CalculationResultProjectionExcelDownloadDto,
} from './calculation-result-projection.models';

@Component({
  selector: 'app-calculation-result',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ConfirmationService],
  templateUrl: './calculation-result.html',
  styleUrl: './calculation-result.scss',
})
export class CalculationResult extends BaseCrudComponent<
  CalculationResultProjectionDto,
  CalculationResultCreateDto,
  CalculationResultUpdateDto,
  CalculationResultProjectionExcelDownloadDto
> {
  private readonly orchestratorService = inject(CalculationResultPlanningOrchestratorService);

  service: ICrudService<
    CalculationResultProjectionDto,
    CalculationResultCreateDto,
    CalculationResultUpdateDto,
    CalculationResultProjectionExcelDownloadDto
  > = {
    create: (_input: CalculationResultCreateDto) =>
      throwError(() => new Error('Calculation Result is read-only.')),
    update: (_id: number, _input: CalculationResultUpdateDto) =>
      throwError(() => new Error('Calculation Result is read-only.')),
    deleteByIds: (_ids: number[]) =>
      throwError(() => new Error('Calculation Result is read-only.')),
    getList: query => this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
  };
  config = CALCULATIONRESULT_CONFIG;
  fields = CALCULATIONRESULT_FIELDS;

  protected prepareUpdateDto(
    _data: any,
    _selected: CalculationResultProjectionDto,
  ): CalculationResultUpdateDto {
    throw new Error('Calculation Result is read-only.');
  }

  protected getEntityName(): string {
    return 'CalculationResult';
  }
}
